import { MobileBridge } from "@wwg/mobile-bridge";

const mobileBridge = new MobileBridge({
  verbose: true,
});

export default mobileBridge;